import { Constantes } from "../constants/constantsGlobal";
import { RequestChatBotProject, Response } from "../models/interfaceChatBotProject";
import { iResponse } from "../models/interfaceResponse";
  
  export const searchChatbotProject = async (request: RequestChatBotProject): Promise<iResponse>=> {
    try {
      const response = await fetch(Constantes.URI_ChatBotProject, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });
      
      if (response.status == 400) {
        const data = await response.json(); 
        return data; 
      } 
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.statusText}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      //console.error('Error al obtener datos:', error);
      throw error;
    } 
    

  }